import axios from "axios";
import { DigitalMeterApi } from "../api"
const TIMEOUT = 30000;
const SERVER_URL = process.env.VUE_APP_IOT_SERVER_URL;
const TOKEN = process.env.VUE_APP_IOT_TOKEN;
export class DigitalMeter {
  constructor() { }

  static async getLatestMeterData(partner, type, cust_id, meter_address, datetime) {
    let url = `${SERVER_URL}/api/meter/electric/data`;
    let { data } = await axios({
      method: 'get',
      url: url,
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      },
      params: {
        partner: partner,
        type: type,
        cust_id: cust_id,
        meter_address: meter_address,
        datetime: datetime
      },
      timeout: TIMEOUT,
    });
    let hashData = {}
    for (let key in data.data) {
      let _data = data.data[key]
      hashData[`${data.cust_id}_${key}`] = {
        unit: type == 'prepaid' ? Math.round(parseFloat(_data.energy) * 100) / 100 : Math.round(parseFloat(_data.energy)),
        status_unit: _data.status_energy,
        datetime: _data.datetime,
        isOffline: _data.isOffline,
        isLowUnit: _data.isLowUnit,
        lowUnit: _data.lowUnit
      }
    }
    return hashData
  }

  static async getLatestMeterStatus(partner, type, cust_id, meter_address) {
    let url = `${SERVER_URL}/api/meter/electric/status`;
    let { data } = await axios({
      method: 'get',
      url: url,
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      },
      params: {
        partner: partner,
        type: type,
        cust_id: cust_id,
        meter_address: meter_address
      },
      timeout: TIMEOUT,
    });
    let hashData = {}
    for (let key in data.data) {
      let _data = data.data[key]
      hashData[`${data.cust_id}_${key}`] = _data
    }
    return hashData
  }

  static async checkBalance(partner, type, cust_id, meter_address, _datetime) {
    let datetime = _datetime || new Date().toISOString()
    let url = `${SERVER_URL}/api/meter/electric/data`;
    let { data } = await axios({
      method: 'get',
      url: url,
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      },
      params: {
        partner: partner,
        type: type,
        cust_id: cust_id,
        meter_address: meter_address,
        datetime: datetime
      },
      timeout: TIMEOUT,
    });
    let hashData = {}
    for (let key in data.data) {
      let _data = data.data[key]
      hashData[`${data.cust_id}_${key}`] = {
        unit: _data.energy,
        status_unit: _data.status_energy,
        datetime: _data.datetime,
        isOffline: _data.isOffline
      }
    }
    return hashData
  }

  static async getLatestDigitalMeterData(partner, type, cust_id, start_date, end_date) {
    let url = `${SERVER_URL}/api/meter/electric/report/month`;
    let { data } = await axios({
      method: 'get',
      url: url,
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      },
      params: {
        partner: partner,
        type: type,
        cust_id: cust_id,
        start_date: start_date,
        end_date: end_date
      },
      timeout: TIMEOUT,
    });

    return data
  }

  static async addBalanceDigitalMeter(meterId, amount) {
    const { data } = await DigitalMeterApi.addBalanceDigitalMeter(meterId, amount);
    return data.result
  }

  static async resetBalanceDigitalMeter(meterId, amount, note) {
    const { data } = await DigitalMeterApi.resetBalanceDigitalMeter(meterId, amount, note);
    return data.result
  }

  static async turnOnDigitalMeter(meterId, note) {
    const { data } = await DigitalMeterApi.turnOnDigitalMeter(meterId, note);
    return data.result
  }

  static async turnOffDigitalMeter(meterId, note) {
    const { data } = await DigitalMeterApi.turnOffDigitalMeter(meterId, note);
    return data.result
  }
}